import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { userApi } from '~/services/rtkQuery/user';
import { resetStore } from '~/store/slices/app';
import { User } from '~/types/models';

export interface UserState {
  tokens: {
    access: string;
    refresh: string;
  } | null;
  profile: User | null;
}

const initialState: UserState = {
  tokens: null,
  profile: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setTokens(state, action: PayloadAction<{ access: string; refresh: string }>) {
      state.tokens = {
        access: action.payload.access,
        refresh: action.payload.refresh,
      };
    },
  },
  extraReducers: builder => {
    builder.addMatcher(userApi.endpoints.login.matchFulfilled, (state, { payload }) => {
      state.tokens = {
        access: payload.result.data.access_token,
        refresh: payload.result.data.refresh_token,
      };
    });
    builder.addMatcher(userApi.endpoints.refreshToken.matchFulfilled, (state, { payload }) => {
      state.tokens = {
        access: payload.result.data.access_token,
        refresh: payload.result.data.refresh_token,
      };
    });
    builder.addMatcher(userApi.endpoints.getMe.matchFulfilled, (state, { payload }) => {
      state.profile = { ...payload.result.data };
    });
  },
});

export const logout = createAsyncThunk(`${userSlice.name}/logout`, async (_, { dispatch }) => {
  dispatch(resetStore());
});

export const { setTokens } = userSlice.actions;
export const userReducer = userSlice.reducer;
